import type { AddressSuggestion } from "../../models/address-suggestion";

interface SuggestionProps {
  suggestion: AddressSuggestion;
  onSelect: (suggestion: AddressSuggestion) => void;
  isHighlighted?: boolean;
  formatDescription: (suggestion: AddressSuggestion) => string;
}

export const Suggestion = ({ suggestion, onSelect, isHighlighted, formatDescription }: SuggestionProps) => {
  return (
    <li
      className={`relative cursor-pointer select-none py-2 pr-9 pl-3 hover:bg-primary hover:text-white ${
        isHighlighted ? "bg-primary text-white" : "text-gray-900"
      }`}
      onClick={() => onSelect(suggestion)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onSelect(suggestion);
      }}
    >
      {formatDescription(suggestion)}
    </li>
  );
};
